import { CSSProperties } from 'react';

type StyleObjectProps = CSSProperties & {
  [index in string | number]: string;
};

/**
 * Convert inline style to object style for use with react,
 * this function is mainly used on inline styles that comes together with content.
 * @param inlineStyle inline string style
 * @return The style object to use with react
 */
export const getStyleObjectFromString = (inlineStyle: string): CSSProperties => {
  if (!inlineStyle) return {};
  // removes any breakline from original component
  // inlineStyle.replace('\n', '');
  const style: StyleObjectProps = {};
  inlineStyle.split(';').forEach((el: string) => {
    const [property, value] = el.split(':');
    if (!property) return;

    const formattedProperty = property.trim().replace(/-([a-z])/g, function (word) {
      return word[1].toUpperCase();
    });

    style[formattedProperty] = value.trim();
  });

  return style;
};
